/* index.tsx generated by @compiled/babel-plugin v0.32.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import EditorDateIcon from '@atlaskit/icon/glyph/editor/date';
import { Inline, Text, xcss } from '@atlaskit/primitives';
import { renderDateString, useDateLocale } from '../../common/utils/utils';
import messages from './messages';
var wrapperStyles = null;
var nonClickableWrapperStyles = xcss({
  display: 'inline-flex',
  blockSize: 'min-content',
  width: 'max-content',
  height: '32px',
  paddingInlineStart: 'space.075',
  paddingInlineEnd: 'space.150',
  backgroundColor: 'color.background.neutral',
  borderRadius: "var(--ds-border-radius-100, 4px)"
});
export var DateRange = function DateRange(props) {
  var onClick = props.onClick,
    _props$triggerProps = props.triggerProps,
    triggerProps = _props$triggerProps === void 0 ? {} : _props$triggerProps,
    placeholder = props.placeholder,
    date = props.value,
    withTimeScale = props.withTimeScale;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var locale = useDateLocale();
  var noDateSelectedMessage = placeholder ? placeholder : formatMessage(messages.noDateSet);
  var dateLabel = date ? renderDateString(locale, date, placeholder, withTimeScale) : noDateSelectedMessage;
  if (!onClick) {
    return /*#__PURE__*/React.createElement(Inline, {
      alignBlock: "center",
      space: "space.025",
      xcss: nonClickableWrapperStyles,
      testId: "date-range-trigger-wrapper"
    }, /*#__PURE__*/React.createElement(EditorDateIcon, {
      label: "calendar icon"
    }), /*#__PURE__*/React.createElement(Text, {
      weight: "medium",
      color: "color.text.subtle"
    }, dateLabel));
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "date-range-trigger-wrapper",
    className: ax(["_1e0c1txw _4cvr1h6o _1bsb1osq _y3gn1e5h _1n9hze3t _15imzwfg _el891wug _1jfq1psy _1fsj1e5h"])
  }, /*#__PURE__*/React.createElement(Button, _extends({}, triggerProps, {
    shouldFitContainer: true,
    onClick: onClick,
    iconBefore: function iconBefore() {
      return /*#__PURE__*/React.createElement(EditorDateIcon, {
        label: "calendar icon"
      });
    },
    iconAfter: function iconAfter() {
      return /*#__PURE__*/React.createElement(ChevronDownIcon, {
        label: "chevron-down icon"
      });
    },
    testId: "date-range-trigger"
  }), dateLabel));
};